import React from 'react';
import Gallery from './components/Gallery';
import Sidebar from './components/Sidebar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery3d.css';

const paths = {
    root: 'https://azygmunt.com/gallery3d',
    cache: '3dcache',
    images: '3dimages',
    apiToc: 'toc-json.php',
    apiGal: 'gallery-json.php?section='
};

class Gallery3d extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: null,
            currentCategory: null,
            gallery: null,
            currentPhoto: null,
            options: {
                type: 'optimized',
                class: 'anaglyph',
                gap: 2
            }
        };
    }

    //get the list of Categories for the front page as soon as the app loads
    componentDidMount() {
        fetch(`${paths.root}/${paths.apiToc}`)
            .then(res => res.json())
            .then(categories => this.setState({ categories }));
    }

    resetGallery = () => {
        this.setState({ gallery: null, currentCategory: null });
    };

    onPhotoClick = (photo) => {
        this.setState({ currentPhoto: photo });
    };

    onCategoryClick = (category) => {
        fetch(`${paths.root}/${paths.apiGal}${category.id}`)
            .then(res => res.json())
            .then(gallery => {
                this.setState({ gallery, currentCategory: category });
            });
    };

    onOptionChange = (value, name) => {
        if (name === 'type') {
            this.setState({
                options: {
                    type: value,
                    gap: this.state.options.gap
                }
            });
        } else if (name === 'gap') {
            let type = this.state.options.type;
            if (!['parallel', 'crosseye'].includes(type)) {
                type='parallel';
            }
            this.setState({
                options: {
                    type: type,
                    gap: value
                }
            });
        }
    };

    render() {
        return (
            <Container fluid={true} id="gallery3d">
                <Row>
                    <Col
                        id="header"
                        onClick={this.resetGallery}>
                        <h1>3D Gallery</h1>
                    </Col>
                </Row>
                <Row>
                    <Col sm={4} md={3} lg={2}>
                        <Sidebar
                            categories={this.state.categories}
                            onClick={this.onCategoryClick}
                            onChange={this.onOptionChange}
                            currentCategory={this.state.currentCategory}
                            paths={paths}
                            options={this.state.options}
                        />
                    </Col>
                    <Col id="gallery">
                        <Gallery
                            gallery={this.state.gallery}
                            currentCategory={this.state.currentCategory}
                            paths={paths}
                            onClick={this.onPhotoClick}
                            options={this.state.options}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Gallery3d;
